import { Megaphone, PackageSearch, TrendingUp, Truck } from "lucide-react";
import { ADVANTAGES } from "@/constants/site";
import { Reveal } from "@/lib/motion";

const ICONS = { Megaphone, PackageSearch, TrendingUp, Truck };

export const Advantages = ({ content = {} }) => (
  <section id="avantajlar" data-testid="advantages-section" className="bg-surface py-24 lg:py-32">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <Reveal>
        <div className="max-w-2xl">
          <span className="text-xs font-semibold uppercase tracking-[0.2em] text-brand">
            {content.advantages_eyebrow || "Neden Nolena Global?"}
          </span>
          <h2 className="mt-4 font-heading font-bold text-ink text-3xl sm:text-4xl lg:text-5xl leading-tight tracking-tight">
            {content.advantages_title || "Bayilik avantajları."}
          </h2>
        </div>
      </Reveal>

      <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
        {(content.advantages?.length ? content.advantages : ADVANTAGES).map((adv, i) => {
          const Icon = ICONS[adv.icon];
          return (
            <Reveal key={adv.title} delay={i * 0.08}>
              <div
                data-testid={`advantage-card-${i}`}
                className="h-full rounded-3xl border border-detail bg-cream p-7 transition-colors duration-300 hover:border-brand/40"
              >
                <span className="flex h-14 w-14 items-center justify-center rounded-2xl bg-detail text-brand">
                  <Icon className="h-6 w-6" />
                </span>
                <h3 className="mt-5 font-heading font-semibold text-lg text-ink">
                  {adv.title}
                </h3>
                <p className="mt-2 text-sm text-ink/65 leading-relaxed">{adv.text}</p>
              </div>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
